<template>
  <base-section
    id="proceedings"
  >
    <v-container>
    <base-section-heading
      title="Proceedings"
      :toColor="true"
      align="left"
      color="secondary"
    >
    If you want to download the zip folder with the preliminary version of the proceedings please insert below the password you were provided with after your registration to the conference and <strong>click the button to download</strong>.
    </base-section-heading>
      <v-row align="left">
      <v-col
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
      >
      <v-text-field
          id="pass-premium"
          ref="passpremium"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          v-model="pass"
          lazy-validation
          label="Insert the password to download"
          filled
          rounded
      />
      </v-col>
      <v-col
        v-if="errsub"
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
      >
        <v-alert
          outlined
          type="error"
          text
        >
          <v-row align="center">
            <v-col class="grow">
              The password inserted is not correct
            </v-col>
            <v-col class="shrink">
              <v-btn
                color="error"
                @click="errsub = !errsub"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        offset-md="4"
        offset-sm="3"
        style="text-align: center !important; padding: 0px !important"
      >
      <v-btn
        class="font-weight-bold"
        color="primary"
        style="text-align: center !important"
        light
        x-large
        rounded
        @click="login()"
      >
        <v-icon
        left
        dark
        >
        mdi-download
        </v-icon>
        Download the Proceedings
      </v-btn>
      <br><br>
      <div
      v-if="progress"
      >
      <v-progress-circular
      indeterminate
      color="primary"
      ></v-progress-circular>
      </div>
      </v-col>
      </v-row>
    <!--
    <div
      v-if="logged"
    >
    logged
    </div>
    -->
  </v-container>
  </base-section>
</template>
<script>
  import DataService from '../../services/DataService'
  var md5 = require("blueimp-md5")

  export default {
    name: 'ProgramCalendarPremium',

    data: () => ({
      show1: false,
      pass: '',
      errsub: false,
      on: false,
      dialog: null,
      logged: false,
      progress: false,
    }),
    methods: {
      login () {
        this.loading = true
        // this.progress = true
        document.getElementById("pass-premium").setAttribute('disabled', '')
        var data = {
          ps: md5(this.pass),
        }

        DataService.log(data).then((response) => {
          document.getElementById("pass-premium").removeAttribute('disabled')
          this.$refs.passpremium.reset()
          if (response.status === 500) {
            this.errsub = true
          } else {
            this.errsub = false
            this.logged = true
            var url = "https://cas.polito.it/api/LATS2025/api/get_file?ps=" + data.ps
            window.open(url);
          }
        }).catch((e) => {
          this.errsub = true
          document.getElementById("pass-premium").removeAttribute('disabled')
        })

       /*
        DataService.log(data).then(res => res.data.blob())
        .then(blob => {
              var file = window.URL.createObjectURL(blob);
              window.location.assign(file);
        }) // this line automatically starts a download operation
        .catch(err => console.log(err));
        */
       /*
        DataService.log(data).then((response) => {
          document.getElementById("pass-premium").removeAttribute('disabled')
          this.$refs.passpremium.reset()
          if (response.status === 500) {
            this.progress = false
            this.errsub = true
          } else {
            this.errsub = false
          }
          //var file = window.URL.createObjectURL(blob);
          //window.location.assign(file);
          //const blob = new Blob([response.data]);
          const link = document.createElement('a');
          //link.href = window.URL.createObjectURL(blob);
          link.download = 'IEEE_LATS2024_preliminary_papers.zip';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(err => {
            this.errsub = true
            this.progress = false
            document.getElementById("pass-premium").removeAttribute('disabled')
        });
        */
      },
    },
  }
</script>
<style>

/*
#program-calendar-section {
  padding-bottom: 10px !important;
  margin-bottom: -160px !important;
}
*/
</style>